module.exports = __webpack_public_path__ + "static/media/TJ-CommContainer.a196ee98.svg";